import Controller from "./listView.controller";
import template from "./listView.html";

const listView = {
  template,
  controller: Controller,
  transclude: true,
  bindings: {
    fields: "<",
    page: "<",
    limit: "<",
    paginateEvent: "<",
    sortEvent: "<",
    selectedSort: "<",
    transformerMethod: "@",
    itemState: "@",
    noItemsText: "@",
    title: "@",
    titleData: "<",
    resource: "@",
    selectedRowId: "<",
    resourceMethod: "@",
    resourceParams: "<",
    forgetParams: "<",
    transformer: "@",
    activeParams: "<",
    filterEvent: "<",
    filters: "<",
    getInterceptor: "<",

    addItemEvent: "<",
    addOptions: "<",
    addItemResourceMethod: "@",
    addExtraParams: "<",
    addItemCustomizeOptions: "<",
    addItemHiddenFields: "<",
    routes: "<",
    bookings: "<",
    customers: "<",
    companies: "<",
    reUpdateEvent: "<",
    shouldReupdate: "<",
    shouldResetOnError: "<",
    item: "<?",
    dynamicFiltersEvents: "<",
  },
};

export default listView;



// WEBPACK FOOTER //
// ./src/components/listView/listView.component.js